import TableViewToggles from '@rio-cloud/rio-uikit/TableViewToggles';
import type { JSX } from 'react';
import { connect } from 'react-redux';

import type { State } from '../../../reducers';
import { LoadMoreDrivingTimesButtonContainer } from '../../realtime/header/tablesettings/LoadMoreButton.container';
import { getTableViewMode } from '../../realtime/header/tablesettings/redux/tablesettings.redux';
import type { TableViewMode } from '../../realtime/header/tablesettings/redux/types';
import { DrivingTimesTableColGroupsContainer } from '../header/TableColGroups.container';
import { DrivingTimesTableBodyContainer } from './DrivingTimesTableBody.container';
import { DrivingTimesTableHeadContainer } from './DrivingTimesTableHead.container';

interface DrivingTimeTableProps {
    viewType: TableViewMode;
}

const DrivingTimesTable = (props: DrivingTimeTableProps): JSX.Element => {
    const { viewType } = props;

    const tableClassNames = [
        'table',
        'table-sticky',
        'table-layout-fixed',
        'table-column-overflow-hidden',
        'table-bordered',
        'table-head-filled',
        viewType === TableViewToggles.VIEW_TYPE_SINGLE_CARD && 'table-cards table-single-card',
        viewType === TableViewToggles.VIEW_TYPE_MULTI_CARDS && 'table-cards table-multi-cards',
    ].join(' ');

    return (
        <div data-testid={'DrivingTimesTable'}>
            <div>
                <table className={tableClassNames}>
                    <DrivingTimesTableColGroupsContainer />
                    <DrivingTimesTableHeadContainer />
                    <DrivingTimesTableBodyContainer />
                </table>
            </div>
            <LoadMoreDrivingTimesButtonContainer />
        </div>
    );
};

const mapStateToProps = (state: State): DrivingTimeTableProps => ({
    viewType: getTableViewMode(state),
});

export const DrivingTimesTableContainer = connect(mapStateToProps)(DrivingTimesTable);
